<template>
    <v-row>
        <v-col sm="12" cols="12" class="grayBg px-6 pl-3">
            <v-card color="white" class="pa-3 no_border" elevation="0">
                <!-- <v-row>
                    <v-col sm="12" cols="12" class="py-0">
                        <h2 class="mb-0 font_20">{{ $t('daily_cash_collection') }}</h2>
                    </v-col>
                </v-row> -->

                <v-row>
                    <v-col sm="12" cols="12">
                        <gridFullScreen>
                            <template>
                                <kendo-datasource
                                    ref="detialByItems"
                                    :type="'JSON'"
                                    :data="saleDetail"
                                    :group="group"
                                    :server-paging="false"/>
                                <kendo-grid
                                    id="detialByItems" class="grid-function"
                                    :data-source-ref="'detialByItems'"
                                    :editable="false"
                                    :groupable="true"
                                    :column-menu="true"
                                    :noRecords="true"
                                    :sortable="true"
                                    :excel-file-name="$t('daily_cash_collection')+'.xlsx'"
                                    :excel-filterable="true"
                                    :excel-all-pages="true"
                                    :toolbar="['excel']"
                                    :scrollable-virtual="true">
                                    <kendo-grid-column
                                        :field="'store'"
                                        :title="$t('store')"
                                        :width="150"
                                        :hidden="true"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5, color: green !important' }"/>
                                    <kendo-grid-column
                                        :field="'register'"
                                        :title="$t('register')"
                                        :hidden="true"
                                        :width="150"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5, color: green !important' }"/>
                                    <kendo-grid-column
                                        :field="'issuedDate'"
                                        :title="$t('date')"
                                        :width="150"
                                        :template="'#= kendo.toString(new Date(issuedDate), `yyyy-MMM-dd`)#'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'txnNum'"
                                        :title="$t('number')"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'cusType'"
                                        :hidden="true"
                                        :title="$t('customer_type')"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'cusName'"
                                        :title="$t('customer_name')"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'employee'"
                                        :title="$t('sale_person')"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'category'"
                                        :title="$t('category')"
                                        :hidden="true"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'itmNum'"
                                        :title="$t('item_number')"
                                        :width="150"
                                        :hidden="true"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"/>
                                    <kendo-grid-column
                                        :field="'itmName'"
                                        :title="$t('item_name')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'orderType'"
                                        :title="$t('order_type')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'minnute'"
                                        :title="$t('min')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'qty'"
                                        :title="$t('qty')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'price'"
                                        :title="$t('price')"
                                        :width="150"
                                        :template="'#= price.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiamt'"
                                        :title="$t('amount')"
                                        :width="150"
                                        :template="'#= champeiamt.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'discount'"
                                        :title="$t('discount')"
                                        :width="150"
                                        :template="'#= discount.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeivat'"
                                        :title="$t('vat')"
                                        :width="150"
                                        :template="'#= champeivat.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiCash'"
                                        :title="$t('cash_collection')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiVisa'"
                                        :title="$t('visa_card')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiBank'"
                                        :title="$t('bank_transfer')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'amount'"
                                        :title="$t('sale_revenue')"
                                        :width="150"
                                        :template="'#= amount.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'cashier'"
                                        :title="$t('cashier')"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'guesttype'"
                                        :title="$t('guest_type')"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'saleUnit'"
                                        :title="$t('sale_unit')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'issuedDate'"
                                        :title="$t('time')"
                                        :width="150"
                                        :template="'#= kendo.toString(new Date(issuedDate), `hh:mm tt`)#'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiType'"
                                        :title="$t('type')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                </kendo-grid>
                                <LoadingMe
                                    :isLoading="showLoading"
                                    :fullPage="false"
                                    type="loading"
                                    :myLoading="true"
                                    :color="loadingColorAlert"
                                    :alertText="loadingTextAlert"/>
                            </template>
                        </gridFullScreen>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import JSZip from "jszip";
window.JSZip = JSZip;
export default {
    name: 'CashCollection',
    props: {saleDetail: {}},
    components: {
        LoadingMe: () => import(`@/components/Loading`),
        gridFullScreen: () => import("@/components/gridFullScreen"),
    },
    data: () => ({
        showLoading: false,
        loadingAlert: false,
        loadingColorAlert: '',
        loadingTextAlert: '',
        startDate: new Date().toISOString().substring(0, 10),
        endDate: new Date().toISOString().substring(0, 10),
        group: {field: 'txnNum'},
    }),
    computed: {},
    methods: {
    },
};
</script>
<style scoped>
.acc_group header {
    height: 10px !important;
}

table.acc_group tr td {
    border-bottom: 1px solid #ccc;
    padding: 8px;
    vertical-align: middle;
}

table.acc_group tr td:first-child {
    font-weight: 700;
}

table.acc_group tr td:last-child {
    text-align: center;
}

.v-card__actions .v-btn.v-btn {
    padding: 0 16px;
}

.exchange-table.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-family: 'Niradei-Bold', serif;
    color: #000 !important;
    border-top: 1px solid #000 !important;
    border-bottom: 1px solid #000 !important;
    font-size: 15px !important;
}

.exchange-table.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
    color: #000 !important;
    padding: 5px !important;
}

.exchange-table.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child td {
    border-bottom: 1px solid #000 !important;
}

.function_footer {
    padding: 15px;
    display: inline-block;
}

p {
    color: rgba(0, 0, 0, 0.87);
}

.actionBtn {
    height: 47.2px !important;
}

.text_tip {
    font-size: 9px;
    line-height: 10px;
}

@media (max-width: 576px) {

}
</style>
